import { Fragment } from "react";
import { queryResult } from "src/utils/queryResult";
import { ProjectItemDetails } from "./components/ProjectItemDetails";
import { usePdfProjectItemsQueryWithQueryParams } from "./hooks/usePdfProjectItemsQueryWithQueryParams";

export function ProjectItemScopeOfWorkPdf() {
  return queryResult(usePdfProjectItemsQueryWithQueryParams(), {
    data: ({ projectItems }) => {
      const lineItems = (projectItems ?? []).filter((pi) => pi.protoCommitmentLineItemToBuyout);

      return (
        <Fragment>
          <ProjectItemDetails
            id="specificationProjectItems"
            projectItems={lineItems}
            title="Scope of Work - Specifications"
          />
        </Fragment>
      );
    },
  });
}
